// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Teal Theme Color Palette */
  --primary-teal: #11454d;
  --primary-teal-light: #1a6d7a;
  --primary-teal-active: #2a8d9c;
  --accent-mint: #5fb8a5;
  --bg-cream: #f4f1e8;
  --bg-white: #ffffff;
  --border-gray: #e8e6e0;
  --text-dark: #2c3e50;
  --text-medium: #5a6c7d;
  --text-light: #8897a8;
  --deep-navy: #0a2a30;
  --success: #5fb8a5;
  --error: #e57373;
  --warning: #ffb74d;

  /* Typography */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  line-height: 1.6;
  font-weight: 400;

  color-scheme: light;
  color: var(--text-dark);
  background-color: var(--bg-cream);

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

a {
  font-weight: 500;
  color: var(--primary-teal);
  text-decoration: none;
  transition: all 0.3s ease;
}
a:hover {
  color: var(--primary-teal-light);
}

body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
  background: var(--bg-cream);
}

h1 {
  font-size: 2.5em;
  line-height: 1.2;
  color: var(--text-dark);
  font-weight: 600;
}

h2 {
  font-size: 2em;
  line-height: 1.3;
  color: var(--text-dark);
  font-weight: 600;
}

h3 {
  font-size: 1.5em;
  line-height: 1.4;
  color: var(--text-dark);
  font-weight: 600;
}

button {
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 0.75em 1.5em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: var(--primary-teal);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);
}

button:hover {
  background-color: var(--primary-teal-light);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);
}

button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(17, 69, 77, 0.2);
}

button:disabled {
  background-color: var(--border-gray);
  color: var(--text-light);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

button:focus,
button:focus-visible {
  outline: 2px solid var(--primary-teal);
  outline-offset: 2px;
}

input,
textarea,
select {
  border-radius: 8px;
  border: 1px solid var(--border-gray);
  padding: 0.75em;
  font-size: 1em;
  font-family: inherit;
  background-color: var(--bg-white);
  color: var(--text-dark);
  transition: all 0.3s ease;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--primary-teal);
  box-shadow: 0 0 0 3px rgba(17, 69, 77, 0.1);
}

::placeholder {
  color: var(--text-light);
}

/* Smooth scrollbar */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: var(--bg-cream);
}

::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--primary-teal-light);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;;EAElB,eAAe;EACf,iHAAiH;EACjH,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;;EAEjC,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[":root {\n  /* Teal Theme Color Palette */\n  --primary-teal: #11454d;\n  --primary-teal-light: #1a6d7a;\n  --primary-teal-active: #2a8d9c;\n  --accent-mint: #5fb8a5;\n  --bg-cream: #f4f1e8;\n  --bg-white: #ffffff;\n  --border-gray: #e8e6e0;\n  --text-dark: #2c3e50;\n  --text-medium: #5a6c7d;\n  --text-light: #8897a8;\n  --deep-navy: #0a2a30;\n  --success: #5fb8a5;\n  --error: #e57373;\n  --warning: #ffb74d;\n\n  /* Typography */\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  line-height: 1.6;\n  font-weight: 400;\n\n  color-scheme: light;\n  color: var(--text-dark);\n  background-color: var(--bg-cream);\n\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\na {\n  font-weight: 500;\n  color: var(--primary-teal);\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\na:hover {\n  color: var(--primary-teal-light);\n}\n\nbody {\n  margin: 0;\n  min-width: 320px;\n  min-height: 100vh;\n  background: var(--bg-cream);\n}\n\nh1 {\n  font-size: 2.5em;\n  line-height: 1.2;\n  color: var(--text-dark);\n  font-weight: 600;\n}\n\nh2 {\n  font-size: 2em;\n  line-height: 1.3;\n  color: var(--text-dark);\n  font-weight: 600;\n}\n\nh3 {\n  font-size: 1.5em;\n  line-height: 1.4;\n  color: var(--text-dark);\n  font-weight: 600;\n}\n\nbutton {\n  border-radius: 10px;\n  border: 1px solid transparent;\n  padding: 0.75em 1.5em;\n  font-size: 1em;\n  font-weight: 500;\n  font-family: inherit;\n  background-color: var(--primary-teal);\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.15);\n}\n\nbutton:hover {\n  background-color: var(--primary-teal-light);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(17, 69, 77, 0.25);\n}\n\nbutton:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(17, 69, 77, 0.2);\n}\n\nbutton:disabled {\n  background-color: var(--border-gray);\n  color: var(--text-light);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\nbutton:focus,\nbutton:focus-visible {\n  outline: 2px solid var(--primary-teal);\n  outline-offset: 2px;\n}\n\ninput,\ntextarea,\nselect {\n  border-radius: 8px;\n  border: 1px solid var(--border-gray);\n  padding: 0.75em;\n  font-size: 1em;\n  font-family: inherit;\n  background-color: var(--bg-white);\n  color: var(--text-dark);\n  transition: all 0.3s ease;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  border-color: var(--primary-teal);\n  box-shadow: 0 0 0 3px rgba(17, 69, 77, 0.1);\n}\n\n::placeholder {\n  color: var(--text-light);\n}\n\n/* Smooth scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-cream);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-teal-light);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
